import { Button } from "devextreme-react";
import { useNavigate } from "react-router-dom";

import { Pages } from "@/shared/constants";

interface IProps {
  nextPage: Pages;
}

const NextButton = ({ nextPage }: IProps) => {
  const navigate = useNavigate();

  const handleGotoNextPage = () => {
    navigate(nextPage);
  };

  return <Button type="default" icon="arrowright" text="NEXT" className="float-end" onClick={handleGotoNextPage} />;
};

export default NextButton;
